// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var MultipleChoiceDefaultForm$ReactHooksTemplate = require("./MultipleChoiceDefaultForm.res.js");

function MultipleChoiceForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var multipleChoice = props.multipleChoice;
  var match = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(MultipleChoiceDefaultForm$ReactHooksTemplate.make, {
                  multipleChoice: multipleChoice,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                      text: MultipleChoice$ReactHooksTemplate.getTextTranslation(multipleChoice, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: MultipleChoice$ReactHooksTemplate.getDescriptionTranslation(multipleChoice, SurveyLanguage$ReactHooksTemplate.name(language)),
                      mandatory: mandatory,
                      surveyTheme: props.surveyTheme,
                      substitutionVariables: substitutionVariables
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("label", {
                            children: $$Array.of_list(Belt_List.mapWithIndex(MultipleChoice$ReactHooksTemplate.getChoicesTranslation(multipleChoice, SurveyLanguage$ReactHooksTemplate.name(language)), (function (param, param$1) {
                                        var id = param$1[0];
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                          checked: MultipleChoice$ReactHooksTemplate.$eq(multipleChoice, id),
                                                          label: param$1[1],
                                                          handleChange: (function (param) {
                                                              Curry._1(onChange, MultipleChoice$ReactHooksTemplate.setAnswer(multipleChoice, id));
                                                            }),
                                                          className: " p-2 border border-white-300 rounded-full\n                    flex w-3/4 small:w-full mb-2 "
                                                        }),
                                                    className: "pb-2"
                                                  }, id);
                                      }))),
                            className: "block mb-10-px"
                          }),
                      className: "flex flex-col"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex flex-col py-8 px-16 small:px-6"
            });
}

var make = MultipleChoiceForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
